import React, { useEffect, useState } from 'react';
import { Black, Dark, Gray20, Shadow, WerfenColor, White } from '../../Constants/ColorChart'
import { connect } from 'react-redux'
import '@phuocng/react-pdf-viewer/cjs/react-pdf-viewer.css';
import styled from 'styled-components';
import isElectron from "is-electron";
import Loader from "../Loader/Loader";
import { Worker } from "@phuocng/react-pdf-viewer";
import SimplerToolbar from "../SimplerToolbar/SimplerToolbar";

const PDFViewerWrapper = styled.div`
    display: inline-block;
    height: 100vh;
    .PDFViewerViewport {
        height: calc(100% - 50px);
        width: 100vw;
        .viewer-layout-container {
            border: 0 none transparent;
        }
        .viewer-layout-toolbar {
            background-color: ${ Dark };
            .viewer-icon {
                stroke: white;
                stroke-width: 1.5px;
            }
            .viewer-button:hover {
                background-color: ${ Gray20 };
            }
            .viewer-progress-bar {
                background-color: ${ White };
            }
            .viewer-zoom-popover-target-arrow {
                border-color: ${ White } transparent transparent;
            }
        }
    }
    .PDFViewer_commandToolbar {
        align-items: center;
        display: flex;
        width: 100%;
        .viewer_layout-toolbar-left {
            align-items: center;
            display: flex;
            flex-grow: 0;
            flex-shrink: 1;
            justify-content: flex-start;
        }
        .viewer_layout-toolbar-center {
            align-items: center;
            display: flex;
            flex-grow: 1;
            flex-shrink: 1;
            justify-content: center;
        }
        .viewer_layout-toolbar-right {
            align-items: center;
            display: flex;
            flex-grow: 0;
            flex-shrink: 1;
            justify-content: flex-end;
        }
    }
    .viewer-tooltip-body,
    .viewer-popover-overlay,
    .viewer-popover-body {
        position: fixed;
        z-index: 10;
    }
    .viewer-popover-body {
        top:95px!important;
        color: ${ Black }
    }
    .viewer-primary-button {
        background: ${ Dark };
        border-radius: 0;
    }
    .viewer-doc-loading {
        display: none;
    }

    .viewer-spinner {
        display: none;
    }
    .viewer-search-popover-label-checkbox {
        margin: 0 8px 0 0;
    }
`;

const PDFViewer = ( props ) => {
    const { isDownloaded, src, isNetworkAvailable/*, isServerReachable*/ } = props;
    const canConnect = isNetworkAvailable //&& isServerReachable;
    const [ showLoader, setShowLoader ] = useState( true );
    const [ fileRetrieved, setFileRetrieved ] = useState( false );
    const [ filename, setFilename ] = useState( null );

    let workerURL = "/pdf.worker.min.js"
    if ( window.location.protocol != "http:" && window.location.protocol != "https:" ) {
        workerURL = "./pdf.worker.min.js";
    }


    const getFile = () => {
        // TODO: This conditional doesn't make much sense
        if ( isDownloaded ) {
            setFileRetrieved( true );
            setFilename( src )
        } else {
            const url = src;
            setFileRetrieved( true );
            setFilename( url )
        }
    }

    const handleIframeTask = ( e ) => {
        switch ( e.data ) {
            case 'closePDFViewer':
                props.handleClose();
                break;
            case 'resourceLoaded':
            case 'exceptionLoading':
                setShowLoader(false);
                break;
            default:
        }
    }

    const onDocumentLoad = () => {
        setShowLoader( false );
    };

    useEffect( () => {
        window.addEventListener( 'message', handleIframeTask );
        getFile();
        return () => {
            window.removeEventListener( 'message', handleIframeTask )
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    return (
        <PDFViewerWrapper className={ "PDFViewerWrapper" }>
            { showLoader &&
            <Loader
                message="Loading"
                primaryColor={ WerfenColor }
                secondaryColor={ Shadow }
                fontColor={ White }
                extraStyle="margin-top: 20vh; margin-left: 50vw; position: absolute; z-index: -1"
            />
            }
            { fileRetrieved &&
            // eslint-disable-next-line
            <Worker workerUrl={ workerURL }>
                <div className={ "PDFViewerViewport" }>
                    <SimplerToolbar
                        onDocumentLoad={ onDocumentLoad }
                        fileUrl={ `${ filename }` }/>
                </div>
            </Worker>
            }
        </PDFViewerWrapper>
    )
}

const mapStateToProps = ( state ) => ({
    session: state.session,
    isNetworkAvailable: state.sensors.isNetworkAvailable,
    isServerReachable: state.sensors.isServerReachable
});

export default connect( mapStateToProps, {} )( PDFViewer );

